export enum Key {
  SessionRememberMe = 'SessionRememberMe',
  EnablePaymentMethodPayPal = 'EnablePaymentMethodPayPal',
  UsePaypalVersion = 'UsePaypalVersion',
  EnablePrintibleStrikeThrough = 'EnablePrintibleStrikeThrough',
  NavBannerInfo = 'NavBannerInfo',
  FloralBoxFeeSetting = 'FloralBoxFeeSetting',
  RelationshipSliderPosition = 'RelationshipSliderPosition',
  TaxSetting = 'EA_Tax_API_Settings',
}

export enum KeyConst {
  PaypalVersion = 'V2',
}
